import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { StyledAddToHomePageButton } from './style';
import { Gradient } from 'utils/types';

type AddToHomePageButtonProps = {
  onClick: () => any;
  borderColor?: string;
  backgroundColor?: Gradient;
  buttonImage?: string;
  isMockPreview?: boolean;
  translations?: Record<string, string>
};

export const AddToHomeScreenButton: React.FC<AddToHomePageButtonProps> = ({
  onClick,
  borderColor = '#FFF',
  backgroundColor = { colorOne: '#522AD8', colorTwo: '#7946FA' },
  buttonImage = '',
  isMockPreview = false,
  translations = {
    addToHomeScreen: "Add to Home Screen"
  }
}) => (
  <StyledAddToHomePageButton
    onClick={onClick}
    borderColor={borderColor}
    bgColor={backgroundColor}
    buttonImage={buttonImage}
    className={isMockPreview ? 'dashboard-preview' : ''}
  >
    {!buttonImage &&
      <>
        <AddCircleOutlineIcon className="icon" style={{ color: borderColor }} />
        <div className="description">
          <div>{translations.addToHomeScreen}</div>
        </div>
      </>
    }
  </StyledAddToHomePageButton>
);
